// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyArchiveWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias } from '../..';

interface ArchiveParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyArchiveWebApiHandler_archive_Path = '/api/web/v1/users/properties/archive';

/**
 * Archive a listing and its dupes
 */
export const RentalManagerUserPropertyArchiveWebApiHandler_archive = (
  getParams: ArchiveParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ArchiveParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyArchiveWebApiHandler_archive_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
